import { render, staticRenderFns } from "./feeitemset-form.vue?vue&type=template&id=696c87cc&scoped=true&"
import script from "./feeitemset-form.vue?vue&type=script&lang=js&"
export * from "./feeitemset-form.vue?vue&type=script&lang=js&"
import style0 from "./feeitemset-form.vue?vue&type=style&index=0&id=696c87cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696c87cc",
  null
  
)

export default component.exports